// @ts-nocheck
const lotteryAdapter = (object, fichas) => {
  const {f_uno_nombre, f_dos_nombre, f_tres_nombre, f_cuatro_nombre, f_cinco_nombre} = object;
  const resultOrdered = [];
  resultOrdered[0] = f_uno_nombre;
  resultOrdered[1] = f_dos_nombre;
  resultOrdered[2] = f_tres_nombre;
  resultOrdered[3] = f_cuatro_nombre;

  if (f_cinco_nombre) {
    resultOrdered[4] = f_cinco_nombre;
  }
  const lastElement = f_cinco_nombre ?? f_cuatro_nombre;
  const traditionalResult = fichas?.find(ficha => ficha.nombre === lastElement);

  return {
    resultOrdered,
    traditionalResult,
    lastElement,
  };
};

/**
 * Validates if a number is a valid three-digit number (000-999)
 * @param {string|number} number - The number to validate
 * @returns {boolean} - True if valid, false otherwise
 */
const isValidThreeDigitNumber = number => {
  const numStr = String(number);
  return /^\d{3}$/.test(numStr);
};

/**
 * Validates if an amount is valid (greater than 0)
 * @param {string|number} amount - The amount to validate
 * @returns {boolean} - True if valid, false otherwise
 */
const isValidAmount = amount => {
  const num = Number(amount);
  return !Number.isNaN(num) && num > 0;
};

/**
 * Process "AGREGAR" bet type - adds the exact number entered for each selected draw
 * @param {string} number - The three-digit number
 * @param {number} amount - The bet amount
 * @param {Array} selectedDraws - Array of selected draw objects with {id, time, name}
 * @returns {Object} - {success: boolean, bets: Array, error: string}
 */
const processAgregarBet = (number, amount, selectedDraws) => {
  // Validate draws
  if (!selectedDraws || selectedDraws.length === 0) {
    return {
      success: false,
      bets: [],
      error: "Debe seleccionar al menos un horario",
    };
  }

  // Validate number
  if (!isValidThreeDigitNumber(number)) {
    return {
      success: false,
      bets: [],
      error: "Debe ingresar un número de 3 dígitos (000-999)",
    };
  }

  // Validate amount
  if (!isValidAmount(amount)) {
    return {
      success: false,
      bets: [],
      error: "El monto debe ser mayor a 0",
    };
  }

  // Create bet for each selected draw
  const bets = selectedDraws.map(draw => ({
    drawId: draw.id,
    drawTime: draw.time,
    drawName: draw.name,
    number: number,
    amount: Number(amount),
    betType: "AGREGAR",
  }));

  return {
    success: true,
    bets,
    error: null,
  };
};

/**
 * Generate all unique permutations of a three-digit number
 * @param {string} number - The three-digit number
 * @returns {Array<string>} - Array of unique permutations
 */
const generatePermutations = number => {
  const digits = number.split("");
  const result = [];

  const permute = (arr, m = []) => {
    if (arr.length === 0) {
      result.push(m.join(""));
    } else {
      for (let i = 0; i < arr.length; i++) {
        const current = arr.slice();
        const next = current.splice(i, 1);
        permute(current.slice(), m.concat(next));
      }
    }
  };

  permute(digits);

  // Remove duplicates (in case of repeated digits like 111 or 121)
  return [...new Set(result)];
};

/**
 * Process "PERMUTA" bet type - bets on all permutations of the three digits
 * @param {string} number - The three-digit number
 * @param {number} amount - The bet amount per permutation
 * @param {Array} selectedDraws - Array of selected draw objects with {id, time, name}
 * @returns {Object} - {success: boolean, bets: Array, error: string, totalAmount: number, permutations: Array}
 */
const processPermutaBet = (number, amount, selectedDraws) => {
  // Validate draws
  if (!selectedDraws || selectedDraws.length === 0) {
    return {
      success: false,
      bets: [],
      error: "Debe seleccionar al menos un horario",
      totalAmount: 0,
      permutations: [],
    };
  }

  // Validate number
  if (!isValidThreeDigitNumber(number)) {
    return {
      success: false,
      bets: [],
      error: "Debe ingresar un número de 3 dígitos (000-999)",
      totalAmount: 0,
      permutations: [],
    };
  }

  // Validate amount
  if (!isValidAmount(amount)) {
    return {
      success: false,
      bets: [],
      error: "El monto debe ser mayor a 0",
      totalAmount: 0,
      permutations: [],
    };
  }

  // Generate all permutations
  const permutations = generatePermutations(number);
  const amountPerBet = Number(amount);
  const bets = [];

  // Create a bet for each permutation in each selected draw
  selectedDraws.forEach(draw => {
    permutations.forEach(permutation => {
      bets.push({
        drawId: draw.id,
        drawTime: draw.time,
        drawName: draw.name,
        number: permutation,
        amount: amountPerBet,
        betType: "PERMUTA",
        originalNumber: number, // Keep track of the original input
      });
    });
  });

  const totalAmount = bets.length * amountPerBet;

  return {
    success: true,
    bets,
    error: null,
    totalAmount,
    permutations,
  };
};

/**
 * Generate serie numbers - changes the FIRST digit from 0-9, keeps the last two digits
 * Example: 123 → 023, 123, 223, 323, 423, 523, 623, 723, 823, 923
 * @param {string} number - The three-digit number
 * @returns {Array<string>} - Array of serie numbers (10 numbers)
 */
const generateSerie = number => {
  const lastTwoDigits = number.substring(1); // Keep digits at positions 1 and 2
  const serie = [];

  for (let i = 0; i <= 9; i++) {
    serie.push(`${i}${lastTwoDigits}`);
  }

  return serie;
};

/**
 * Generate corrida numbers - changes the LAST digit from 0-9, keeps the first two digits
 * Example: 123 → 120, 121, 122, 123, 124, 125, 126, 127, 128, 129
 * @param {string} number - The three-digit number
 * @returns {Array<string>} - Array of corrida numbers (10 numbers)
 */
const generateCorrida = number => {
  const firstTwoDigits = number.substring(0, 2); // Keep digits at positions 0 and 1
  const corrida = [];

  for (let i = 0; i <= 9; i++) {
    corrida.push(`${firstTwoDigits}${i}`);
  }

  return corrida;
};

/**
 * Process "SERIE" bet type - bets on all numbers with first digit changing (0-9)
 * @param {string} number - The three-digit number
 * @param {number} amount - The bet amount per number
 * @param {Array} selectedDraws - Array of selected draw objects with {id, time, name}
 * @returns {Object} - {success: boolean, bets: Array, error: string, totalAmount: number, serieNumbers: Array}
 */
const processSerieBet = (number, amount, selectedDraws) => {
  // Validate draws
  if (!selectedDraws || selectedDraws.length === 0) {
    return {
      success: false,
      bets: [],
      error: "Debe seleccionar al menos un horario",
      totalAmount: 0,
      serieNumbers: [],
    };
  }

  // Validate number
  if (!isValidThreeDigitNumber(number)) {
    return {
      success: false,
      bets: [],
      error: "Debe ingresar un número de 3 dígitos (000-999)",
      totalAmount: 0,
      serieNumbers: [],
    };
  }

  // Validate amount
  if (!isValidAmount(amount)) {
    return {
      success: false,
      bets: [],
      error: "El monto debe ser mayor a 0",
      totalAmount: 0,
      serieNumbers: [],
    };
  }

  // Generate serie numbers
  const serieNumbers = generateSerie(number);
  const amountPerBet = Number(amount);
  const bets = [];

  // Create a bet for each serie number in each selected draw
  selectedDraws.forEach(draw => {
    serieNumbers.forEach(serieNum => {
      bets.push({
        drawId: draw.id,
        drawTime: draw.time,
        drawName: draw.name,
        number: serieNum,
        amount: amountPerBet,
        betType: "SERIE",
        originalNumber: number,
      });
    });
  });

  const totalAmount = bets.length * amountPerBet;

  return {
    success: true,
    bets,
    error: null,
    totalAmount,
    serieNumbers,
  };
};

/**
 * Process "CORRIDA" bet type - bets on all numbers with last digit changing (0-9)
 * @param {string} number - The three-digit number
 * @param {number} amount - The bet amount per number
 * @param {Array} selectedDraws - Array of selected draw objects with {id, time, name}
 * @returns {Object} - {success: boolean, bets: Array, error: string, totalAmount: number, corridaNumbers: Array}
 */
const processCorridaBet = (number, amount, selectedDraws) => {
  // Validate draws
  if (!selectedDraws || selectedDraws.length === 0) {
    return {
      success: false,
      bets: [],
      error: "Debe seleccionar al menos un horario",
      totalAmount: 0,
      corridaNumbers: [],
    };
  }

  // Validate number
  if (!isValidThreeDigitNumber(number)) {
    return {
      success: false,
      bets: [],
      error: "Debe ingresar un número de 3 dígitos (000-999)",
      totalAmount: 0,
      corridaNumbers: [],
    };
  }

  // Validate amount
  if (!isValidAmount(amount)) {
    return {
      success: false,
      bets: [],
      error: "El monto debe ser mayor a 0",
      totalAmount: 0,
      corridaNumbers: [],
    };
  }

  // Generate corrida numbers
  const corridaNumbers = generateCorrida(number);
  const amountPerBet = Number(amount);
  const bets = [];

  // Create a bet for each corrida number in each selected draw
  selectedDraws.forEach(draw => {
    corridaNumbers.forEach(corridaNum => {
      bets.push({
        drawId: draw.id,
        drawTime: draw.time,
        drawName: draw.name,
        number: corridaNum,
        amount: amountPerBet,
        betType: "CORRIDA",
        originalNumber: number,
      });
    });
  });

  const totalAmount = bets.length * amountPerBet;

  return {
    success: true,
    bets,
    error: null,
    totalAmount,
    corridaNumbers,
  };
};

/**
 * Validates if a number is a valid two-digit number (00-99)
 * @param {string|number} number - The number to validate
 * @returns {boolean} - True if valid, false otherwise
 */
const isValidTwoDigitNumber = number => {
  const numStr = String(number);
  return /^\d{1,2}$/.test(numStr);
};

/**
 * Process "AGREGAR" bet type for Terminal games - adds the exact number entered for each selected draw
 * @param {string} number - The two-digit number (0-99)
 * @param {number} amount - The bet amount
 * @param {Array} selectedDraws - Array of selected draw objects with {id, time, name}
 * @returns {Object} - {success: boolean, bets: Array, error: string}
 */
const processAgregarBetTerminal = (number, amount, selectedDraws) => {
  // Validate draws
  if (!selectedDraws || selectedDraws.length === 0) {
    return {
      success: false,
      bets: [],
      error: "Debe seleccionar al menos un horario",
    };
  }

  // Validate number
  if (!isValidTwoDigitNumber(number)) {
    return {
      success: false,
      bets: [],
      error: "Debe ingresar un número de 2 dígitos (00-99)",
    };
  }

  // Validate amount
  if (!isValidAmount(amount)) {
    return {
      success: false,
      bets: [],
      error: "El monto debe ser mayor a 0",
    };
  }

  // Create bet for each selected draw
  const bets = selectedDraws.map(draw => ({
    drawId: draw.id,
    drawTime: draw.time,
    drawName: draw.name,
    number: number,
    amount: Number(amount),
    betType: "AGREGAR",
  }));

  return {
    success: true,
    bets,
    error: null,
  };
};

export {
  isValidAmount,
  isValidThreeDigitNumber,
  isValidTwoDigitNumber,
  lotteryAdapter,
  processAgregarBet,
  processAgregarBetTerminal,
  processCorridaBet,
  processPermutaBet,
  processSerieBet,
};
